import script from "./VoucherAmountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherAmountPage.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherAmountPage.vue?vue&type=style&index=0&id=cb052a96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb052a96"]])

export default __exports__